import "./index.css";
import React, { useEffect, useRef, useState } from "react";
import { VIDEO_UPLOAD, YOUTUBE_URL } from "../../../../Constants/types";
import VideoPlayer from "../../../../components/VideoPlayer";
import MoreButton from "../MoreButton";
import Firebase from "../../../../firebasehelper";
import StatusButton from "../../../../components/StatusButton";

export default function PortfolioCard({
  portfolio,
  brandIcon,
  brandId,
  onEditPortfolio,
}) {
  const [openDropdownId, setOpenDropdownId] = useState(false);

  const dropdownRef = useRef();

  useEffect(() => {
    const onOutsideClick = (e) => {
      if (!dropdownRef.current.contains(e.target) && openDropdownId !== null) {
        setOpenDropdownId(null);
      }
    };

    document.addEventListener("mousedown", onOutsideClick);
    return () => document.removeEventListener("mousedown", onOutsideClick);
  }, []);

  const handleMoreBtnClick = (e) => {
    e.stopPropagation();
    setOpenDropdownId((prevId) =>
      prevId === portfolio.id ? null : portfolio.id
    );
  };

  const onToggleStatus = async () => {
    const updatedData = { isPublic: !portfolio.isPublic, id: portfolio.id };
    try {
      setOpenDropdownId(null);
      await Firebase.updateBrandPortfolioById(brandId, updatedData);
    } catch (e) {
      console.error("updatePortfolios error", e);
    }
  };

  return (
    <article className="portfolio-card">
      <div className="portfolio-card__img-container">
        {portfolio.media[0].mediaType === VIDEO_UPLOAD ||
        portfolio.media[0].mediaType === YOUTUBE_URL ? (
          <VideoPlayer
            src={portfolio.media[0].mediaUrl}
            isUploadedVideo={portfolio.media[0].mediaType === VIDEO_UPLOAD}
            className="portfolio-card__video"
          />
        ) : (
          <img
            src={portfolio.media[0].uploads[0].mediaUrl}
            alt="portfolio banner"
            className="portfolio-card__img"
          />
        )}
        <div className="portfolio-card__icon-container">
          <img
            src={brandIcon}
            alt="brand icon"
            className="portfolio-card__icon"
          />
        </div>
      </div>
      <div className="portfolio-card__content">
        <div className="portfolio-card__container">
          <h4 className="portfolio-card__name" title={portfolio.name}>
            {portfolio.name}
          </h4>
          <MoreButton
            toggleStatus={onToggleStatus}
            isPublic={portfolio.isPublic}
            isOpen={openDropdownId === portfolio.id}
            onClick={(e) => handleMoreBtnClick(e, portfolio.id)}
            dropdownRef={dropdownRef}
            onEditPortfolio={() => {
              onEditPortfolio(portfolio);
              setOpenDropdownId(null);
            }}
          />
        </div>
        <ul className="portfolio-card__list">
          {portfolio.contents.map((content) => {
            return content.text.length ? (
              <li
                className="portfolio-card__list-item"
                key={`${portfolio.name}-${content.id}`}
                title={content.text}
              >
                {content.text}
              </li>
            ) : null;
          })}
        </ul>
      </div>
      <div className="portfolio-card__bottom-container">
        <StatusButton isPublic={portfolio.isPublic} isDisabled={true} />
      </div>
    </article>
  );
}



// WEBPACK FOOTER //
// ./src/screens/ProductPortfolio/components/PortfolioCard/index.js